import { defineMessages } from "react-intl";
export default defineMessages({
    airQuality: {
        id: "airQuality.airQuality",
        defaultMessage: "Air quality",
    },
    airQualityIndex: {
        id: "airQuality.airQualityIndex",
        defaultMessage: "Air quality index",
    },
    co: {
        id: "airQuality.co",
        defaultMessage: "Carbon monoxide",
    },
    good: {
        id: "airQuality.good",
        defaultMessage: "Good",
    },
    goodDescription: {
        id: "airQuality.goodDescription",
        defaultMessage: "Air quality is considered satisfactory, and air pollution poses little or no risk",
    },
    hazardous: {
        id: "airQuality.hazardous",
        defaultMessage: "Hazardous",
    },
    hazardousDescription: {
        id: "airQuality.hazardousDescription",
        defaultMessage: "Health alert: anyone may experience more serious health effects",
    },
    indoorAirQuality: {
        id: "airQuality.indoorAirQuality",
        defaultMessage: "Indoor air quality",
    },
    moderate: {
        id: "airQuality.moderate",
        defaultMessage: "Moderate",
    },
    moderateDescription: {
        id: "airQuality.moderateDescription",
        defaultMessage: "Air quality is acceptable; however, for some pollutants there may be a moderate health concern for a very small number of people who are unusually sensitive to air pollution.",
    },
    no2: {
        id: "airQuality.no2",
        defaultMessage: "Nitrogen dioxide",
    },
    o3: {
        id: "airQuality.o3",
        defaultMessage: "Ozone",
    },
    pm10: {
        id: "airQuality.pm10",
        defaultMessage: "Particles with a diameter of 10 μm or less",
    },
    pm25: {
        id: "airQuality.pm25",
        defaultMessage: "Particles with a diameter of 2.5 μm or less",
    },
    sensitiveUnhealthy: {
        id: "airQuality.sensitiveUnhealthy",
        defaultMessage: "Unhealthy for sensitive people",
    },
    sensitiveUnhealthyDescription: {
        id: "airQuality.sensitiveUnhealthyDescription",
        defaultMessage: "Members of sensitive groups may experience health effects. The general public is not likely to be affected.",
    },
    so2: {
        id: "airQuality.so2",
        defaultMessage: "Sulfur dioxide",
    },
    unhealthy: {
        id: "airQuality.unhealthy",
        defaultMessage: "Unhealthy",
    },
    unhealthyDescription: {
        id: "airQuality.unhealthyDescription",
        defaultMessage: "Everyone may begin to experience health effects; members of sensitive groups may experience more serious health effects",
    },
    veryUnhealthy: {
        id: "airQuality.veryUnhealthy",
        defaultMessage: "Very unhealthy",
    },
    veryUnhealthyDezscription: {
        id: "airQuality.veryUnhealthyDezscription",
        defaultMessage: "Health warnings of emergency conditions. The entire population is more likely to be affected.",
    },
    aqiForecast: {
        id: "airQuality.aqiForecast",
        defaultMessage: "AQI Forecast",
    },
    details: {
        id: "airQuality.details",
        defaultMessage: "Details",
    },
    dailyForecast: {
        id: "airQuality.dailyForecast",
        defaultMessage: "Daily forecast",
    },
    ugm3: {
        id: "airQuality.ugm3",
        defaultMessage: "µg/m³",
    },
    mgm3: {
        id: "airQuality.mgm3",
        defaultMessage: "mg/m³",
    },
    ppb: {
        id: "airQuality.ppb",
        defaultMessage: "ppb",
    },
    dominantPollutant: {
        id: "airQuality.dominantPollutant",
        defaultMessage: "Dominant pollutant",
    },
});
